import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-camp-category',
    templateUrl: './camp-category.component.html',
    styleUrls: ['./camp-category.component.scss'],
    standalone: false
})
export class CampCategoryComponent implements OnInit {
  
    @Input() public form : UntypedFormGroup;

    constructor() { 

    }

    ngOnInit(): void {
        
    }

}
